import React from 'react';
import { motion } from 'framer-motion';

const CTA = ({ onReserveClick }) => {
  return (
    <section id="cta" className="relative py-20 bg-cover bg-center" style={{ backgroundImage: `url('/images/cta-bg.jpg')` }}>
      <div className="absolute inset-0 bg-black/60"></div> {/* Overlay */}
      <div className="relative container mx-auto px-4 text-center text-white">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-4xl md:text-5xl font-playfair font-extrabold mb-6"
        >
          ¡Tu Aventura Amazónica te Espera!
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-lg md:text-xl max-w-3xl mx-auto mb-10"
        >
          Sumérgete en la belleza de la selva y vive una experiencia inolvidable con Sumaq Mayu.
        </motion.p>
        <motion.button
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          whileHover={{ scale: 1.05, boxShadow: '0 8px 25px rgba(255, 255, 255, 0.2)' }}
          whileTap={{ scale: 0.95 }}
          onClick={onReserveClick}
          className="bg-green-600 text-white py-4 px-10 text-lg font-semibold rounded-lg shadow-lg hover:bg-green-700 transition-all duration-300 uppercase tracking-wide"
        >
          RESERVAR AHORA
        </motion.button>
      </div>
    </section>
  );
};

export default CTA;
